import * as types from '../actions/actionTypes';

const defaultState = {
  detail : {},
  listLanguage: [
    // {
    //   "value": "vi",
    //   "label": "Tiếng Việt"
    // },
    // {
    //   "value": "en",
    //   "label": "English"
    // }
  ],
  isDeleteSession: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.MVP_GET_LIST_LANGUAGE:
      return { ...state, listLanguage: action.data };
    case types.FETCH_SESSION_DETAIL_SUCCESS:
      return { ...state, detail: action.data };
    case types.RESET_SUBMIT_SESSION:
      return {
        ...state,
        detail: {},
      };
    case types.FETCH_REMOVE_SESSION_SUCCESS:
      return { ...state, isDeleteSession: action.isDeleteSession };
    default:
      return state;
  }
};
